import React from "react";
import MaterialTable, { MTableAction, MTableEditRow, MTableToolbar, MTableActions } from "material-table";
import I18n from "core/I18n/I18n";
import keyEnum from "core/I18n/KeyEnum";
import { Button } from 'reactstrap';
import { muiTheme } from './tableTheme';
import { MuiThemeProvider } from "@material-ui/core";

class CustomTable extends React.Component {
	constructor(props) {
		console.log({ props })
		super(props);

		this.state = {
			selecteds: []
		}

		this.onRowAdd = this.onRowAdd.bind(this);
		this.onRowDelete = this.onRowDelete.bind(this);
		this.onRowUpdate = this.onRowUpdate.bind(this);
	}

	onRowAdd(newData) {
		return new Promise(resolve => {
			resolve(newData);
		});
	}

	onRowDelete(oldData) {
		return new Promise(resolve => {
			resolve(oldData);
		});
	}

	onRowUpdate(newData, oldData) {
		return new Promise(resolve => {
			resolve({ oldData, newData });
		});
	}

	render() {
		// console.log(this.state.selecteds);
		return (
			<MuiThemeProvider theme={muiTheme}>
				<div className="custom-table">
					<MaterialTable
						editable={{
							onRowAdd: this.props.onRowAdd,
							onRowUpdate: this.props.onRowUpdate,
							onRowDelete: this.props.onRowDelete
						}}
						onSelectionChange={(selecteds) => this.setState({ selecteds })}
						localization={I18n[keyEnum.tableTranslate]}
						{...this.props}
						options={{
							selection: this.props.canSelect,
							sorting: true,
							actionsColumnIndex: -1,
							searchFieldStyle: this.state.selecteds && this.state.selecteds.length > 0 ? { display: "none" } : {},
							...this.props.options
						}}
						components={{
							Toolbar: (item) => {
								const ToolbarAppend = this.props.toolbarAppend;
								return <>
									<div className="custom-table-toolbar">
										<MTableToolbar {...item} />
										{ToolbarAppend && <ToolbarAppend />}
									</div>
								</>
							},
							EditRow: (item) => {
								const newColumns = [];
								item.columns.map(column => {
									if (column.editable) {
										newColumns.push({
											...column,
											title: column.placeholder ? column.placeholder : column.title
										})
									}
								})

								const editProps = {
									...item,
									columns: newColumns
								}

								return this.props.editableRow ? this.props.editableRow(editProps) : <MTableEditRow {...editProps} />;
							},
							Actions: item => {
								// console.log(item);
								return <MTableActions {...item} />
							},
							Action: item => {
								const { action, data } = item;
								// console.log({ action })
								if (action.isFreeAction && action.icon.name === "Add") {
									return (
										<>
											<Button className="button-add truncated" outline color="warning" onClick={(e) => this.props.onAddClick ? this.props.onAddClick() : action.onClick(e, data)}>{this.props.addLabel ? this.props.addLabel : "Adicionar Novo"}</Button>
											<Button className="button-add-fixed btn-round btn-icon" color="warning" onClick={(e) => this.props.onAddClick ? this.props.onAddClick() : action.onClick(e, data)}>
												<i className="nc-icon nc-simple-add" />
											</Button>
										</>
									)
								}

								if (action.icon && action.icon.name === "Edit" && this.props.onEditClick) {
									action.onClick = (_e, data) => {
										// console.log({data});
										this.props.onEditClick(data)
									}
								}

								if (action.icon && action.icon.name === "Delete" && this.props.onDeleteClick) {
									action.onClick = (_e, data) => {
										this.props.onDeleteClick(data)
									}
								}

								return <MTableAction {...item} />;
							},
							...this.props.components
						}}
						actions={[
							rowData => (this.props.treeList && rowData.parent === "") && ({
								icon: 'add',
								iconProps: {
									style: {
										fontSize: 24,
									}
								},
								tooltip: 'Adicionar',
								onClick: (event, rowData) => this.props.onAddChildren(rowData)
							}),
							rowData => this.props.detailsList && ({
								icon: 'more',
								iconProps: {
									style: {
										fontSize: 24,
										color: "#4d4d4d",
										transform: "rotate(180deg)",
									}
								},
								tooltip: 'Detalhes',
								onClick: (event, rowData) => this.props.openDetails(rowData)
							}),
						]}
					/>
				</div>
			</MuiThemeProvider>
		);
	}
}

export default CustomTable;

/*  else if (data) {
								if (action.icon && action.icon.name === "Delete") {

									action.iconProps = {
										style: {
											color: infoColor,
										}
									}
								} else if (action.icon && action.icon.name === "Edit") {
									if (this.props.onEditClick) {
										action.onClick = (e, data) => this.props.onEditClick(data)
									}
									action.iconProps = {
										style: {
											color: infoColor
										}
									};
								}
							}
							return <MTableAction {...item} />; */

/* return (
			<Button className="button-add truncated" outline color="primary" />
		) */